module.exports = __webpack_public_path__ + "img/Sin t├нtulo-1-07.a5927d5d.png";